export default __webpack_public_path__ + "static/media/portfolio-hover-199.ad312d73.jpg";